import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Consumption, Segment } from "@/components/Sections/Energy/Segments";
import { useI18n } from "@/shared/hooks";
import { isGasScale, scaleRecordMap } from "./scaleRecords";
export const fullsizeScaleTestId = "cdp-fullsize-scale";
export const FullsizeScale = ({ efficiencyClass, type, segments, values, name, alternateText, displayUnhappyHouseIcon, }) => {
    const { t } = useI18n();
    const { index: scaleIndex, rating } = efficiencyClass || {};
    const scaleRecords = scaleRecordMap[type] || {};
    const headerText = isGasScale(type)
        ? t("energy.scales.efficient.ghg_high")
        : t("energy.scales.efficient.high");
    const footerText = isGasScale(type)
        ? t("energy.scales.efficient.ghg_low")
        : t("energy.scales.efficient.low");
    return (_jsxs(Box, { testId: fullsizeScaleTestId, marginBottom: "spacing.32", width: "352px", children: [name ? (_jsx(Box, { typography: "typography.body.14.bold", as: "h3", whiteSpace: "nowrap", marginBottom: "spacing.12", children: name })) : null, alternateText ? (_jsx(Box, { typography: "typography.body.14.regular", color: "color.content.light.default", marginBottom: "spacing.24", children: alternateText })) : (_jsxs(_Fragment, { children: [_jsx(Box, { typography: "typography.body.12.regular", marginBottom: "spacing.4", children: headerText }), segments === null || segments === void 0 ? void 0 : segments.map((segment, index) => (_jsx(Segment, { 
                        // @ts-ignore
                        color: scaleRecords[index].color, 
                        // @ts-ignore
                        width: scaleRecords[index].width, 
                        // @ts-ignore
                        path: scaleRecords[index].d, label: segment.label, value: segment.value, 
                        // @ts-ignore
                        textColor: scaleRecords[index].fullsizeTextColor, children: index === scaleIndex ? (_jsx(Consumption, { type: type, rating: rating, 
                            // @ts-ignore
                            color: scaleRecords[index].color, values: values, index: scaleIndex, 
                            // @ts-ignore
                            displayUnhappyHouseIcon: displayUnhappyHouseIcon })) : null }, segment.value))), _jsx(Box, { typography: "typography.body.12.regular", marginTop: "spacing.4", children: footerText })] }))] }));
};
